import styled from "styled-components";

const Wrapper = styled.main`
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  padding: 24px;
`

export default Wrapper